// extracted by mini-css-extract-plugin
export default {"button":"NiIge","title":"P1wnn","addToWalletTitle":"Pr7Ai","spinnerContainer":"BV-OE"};